import React from 'react';
import { Box, SxProps, Theme, Typography } from '@mui/material';

export interface SectionProps {
  title?: string;
  action?: React.ReactNode;
  /** Bottom margin between sections (MUI spacing units) */
  spacing?: number;
  children: React.ReactNode;
  id?: string;
  sx?: SxProps<Theme>;
}

const Section: React.FC<SectionProps> = ({
  title,
  action,
  spacing = 3,
  children,
  id,
  sx
}) => (
  <Box
    component="section"
    id={id}
    sx={{
      mb: spacing,
      scrollMarginTop: id ? 96 : undefined,
      ...sx
    }}
  >
    {(title || action) && (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          mb: 2,
          gap: 2
        }}
      >
        {title && (
          <Typography variant="h6" component="h2" sx={{ fontWeight: 650 }}>
            {title}
          </Typography>
        )}
        {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
      </Box>
    )}
    {children}
  </Box>
);

export default Section;
